module.exports = __webpack_public_path__ + "static/media/CARTA_AUTORIZACION(PF).dae73ba2.jpg";